export const getDeleteEdgesByNodeId = (deleteNode, edges) => {
  const { nodeId } = deleteNode;
  return edges.filter(e => e.source !== nodeId && e.target !== nodeId);
};
